export default angular.module('ArticlesApp', [
    'KhBase',
    'articles_factories',
    'articles_setup_module',
    'content_delivery_system',
    'articles_add_edit_module'
]);
